import {
  ADD_FAVORITE_EVENT,
  REMOVE_FAVORITE_EVENT,
  SET_FAVORITES_FROM_LOCAL_STORAGE
} from 'Store/constants';
import { loadStateFromIndexedDB, storeDataToIndexedDB } from 'Utils/manageIndexedDB';

export const getFavoritesFromLocalStorage = () => dispatch => {
  loadStateFromIndexedDB('favorites', data => {
    dispatch({
      type: SET_FAVORITES_FROM_LOCAL_STORAGE,
      payload: data ? data?.favorites : {}
    });
  });
};

export const addFavoriteEvent = event => (dispatch, getState) => {
  dispatch({
    type: ADD_FAVORITE_EVENT,
    payload: { event: { ...event, id: +event?.id  } }
  });
  storeDataToIndexedDB('favorites', getState().favoriteEvents);
};

export const removeFavoriteEvent = eventId => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    try {
      dispatch({
        type: REMOVE_FAVORITE_EVENT,
        payload: { eventId }
      });
      storeDataToIndexedDB('favorites', getState().favoriteEvents);
      resolve();
    } catch (e) {
      reject(e);
    }
  });
};